// 平均值
const meanNumFun = (list, field) => {
  let count = 0;
  list.forEach(item => {
    count += Number(item[field]);
  });
  return count / list.length;
};
// 合计 相加
const sumNumFun = (list, field, len, text) => {
  let count = 0;
  list.forEach(item => {
    count += Number(item[field].toString().replace(/\$|\,/g, ""));
  });
  return text == "format"
    ? formatNum(parseFloat(count.toFixed(len)))
    : parseFloat(count.toFixed(len));
};
// 数字千分位计数
const formatNum = num => {
  return String(num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
};
export default {
  meanNumFun,
  formatNum,
  sumNumFun
};
